export default "__VITE_ASSET__c2157f2a__"